import { render, staticRenderFns } from "./clazz-stu-list.vue?vue&type=template&id=fe014d0a&scoped=true&"
import script from "./clazz-stu-list.vue?vue&type=script&lang=js&"
export * from "./clazz-stu-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe014d0a",
  null
  
)

export default component.exports